

<div class="public-page">
   <div class="public-container">
      <!-- Main Content -->
      <div class="main-content">
         <div class="fp-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 16 16"><path fill="currentColor" d="M11.5 0h-7C3.675 0 3 .675 3 1.5v13c0 .825.675 1.5 1.5 1.5h7c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5M6 .75h4v.5H6zM8 15a1 1 0 1 1 0-2a1 1 0 0 1 0 2m4-3H4V2h8z"/></svg>
         </div>
         <div class="header-content-fp">
            <h4>Mobile Phone Verification</h4>
            <p>Please enter the verification code we just sent to your WhatsApp number
                 {{mobileNumber}}.</p>
         </div>
         
         <form class="form" [formGroup]="otpForm" (ngSubmit)="verifyOTP()">
            <div class="form-row">
               <div class="otp-box-group">
                        <input
                            *ngFor="let ctrl of otpControls; let i = index"
                            type="text"
                            maxlength="1"
                            pattern="[0-9]*"
                            inputmode="numeric"
                            class="otp-box"
                            [formControl]="ctrl"
                            (input)="onOtpInput($event, i)"
                            (keydown)="onOtpKeyDown($event, i)"
                            autocomplete="one-time-code"
                        />
               </div>
               <div *ngIf="error" class="error">{{ error }}</div>
            </div>
            
            <div class="btn-submit">
                <button type="submit" [disabled]="isSubmitting || otpForm.invalid">Verify OTP</button>
            </div>
           
            <div class="back-login">
                <p *ngIf="timer > 0">Verification code expires in <span class="text-pink-600 font-semibold">{{ timer }}</span> seconds</p><br>
                <p>Didn't receive the code?
                <a (click)="sendOTP()"><strong>Resend</strong></a></p>
            </div>
         </form>
      </div>
   </div>
</div>
